import React from 'react';
import styles from './UnauthorizedPage.module.css';
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import {Stack, StackItem} from "@fluentui/react";
import strings from "../../loc/strings";

const UnauthorizedPage: React.FC = () => {
  return (
      <Stack className={styles.mainLayout}>
          <StackItem>
              <Header/>
          </StackItem>
          <StackItem className={styles.mainContent}>
              <div className={styles.unauthorizedAccess}>
                  <h2>{strings.unauthorizedAccess}</h2>
                  <p>{strings.noPermission}</p>
              </div>
          </StackItem>
          <StackItem>
              <Footer/>
          </StackItem>
      </Stack>
  );
};

export default UnauthorizedPage;